import { OverlayShellConfig } from "../overlay-shell/overlay.models";

export const TASKS_EMAIL_LIST_DIALOG_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
